<script>
export default{
  name: 'ConnectModal',
  data(){
    return{
      isConnecting: true,
      isLoading: false,
      wabaId: null,
      accessToken: null,
    }
  }
}
</script>

<template>
  <div class="fixed inset-0 z-40 flex items-center justify-center p-4">
    <div 
      class="fixed inset-0 z-40 bg-slate-800/20 dark:bg-slate-800/50"
    ></div>

    <div 
      class="w-[560px] top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 bg-white dark:bg-slate-700 dark:text-slate-100 p-4 rounded-md fixed z-50 transition-all duration-300 ease-in-out flex flex-col"
    >
      <label>
        WABA ID (Temporary)
        <input type="text" maxlength="512" v-model="wabaId" placeholder="Enter your WABA ID"/>
      </label>

      <label>
        Access Token (Temporary)
        <input type="text" maxlength="512" v-model="accessToken" placeholder="Enter your access token"/>
      </label>
      
      <div class="flex justify-end gap-4 mt-4">
        <woot-button variant="clear" color-scheme="secondary" @click="$emit('close')">Cancel</woot-button>
        <woot-button 
          variant="clear" 
          color-scheme="primary"
          :disabled="isLoading" 
          @click="$emit('login')"
        >{{ isLoading ? 'Loading' : ( isConnecting ? 'Create' : 'Save' ) }}</woot-button>
      </div>
    </div>
  </div>
</template>